import { CircleFill } from '@lyearn/icons';
import { NewFilterOption } from '@/components/FilterNew/types';
import useProjectStages from '@/modules/tasks/views/TasksDashboard/hooks/useProjectStages';

type Params = NonNullable<ReturnType<typeof useProjectStages>['stages']>[0];

export const getProjectStageFilterOption = (stage: Params): NewFilterOption => {
  return {
    value: stage.stageId,
    label: stage.name,
    Icon: (props) => <CircleFill {...props} color={stage.iconSettings?.value} />,
    item: stage,
  };
};
